/* BLACK MONTH: countdowns */
(function () {
  'use strict';
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function parseEnd(s) {
    if (!s) return null;
    s = String(s).trim();
    if (/[zZ]$|[+-]\d\d:?\d\d$/.test(s)) return new Date(s);
    if (s.length === 16) s += ':00';
    var d = new Date(s + '+01:00'); /* Danish winter time */
    return isNaN(d) ? null : d;
  }

  var tickers = [];
  setInterval(function () { tickers.forEach(function (fn) { fn(); }); }, 1000);

  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-bm-countdown]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var end = parseEnd(el.getAttribute('data-end'));
      if (!end) return;
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var scope = el.closest('[data-bm-campaign]');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (scope) scope.classList.add('bm-ended');
          var txt = el.getAttribute('data-ended-text');
          if (txt && !el.dataset.done) { el.dataset.done = '1'; el.textContent = txt; }
          return;
        }
        var t = Math.floor(diff / 1000);
        if (d) d.textContent = pad(Math.floor(t / 86400));
        if (h) h.textContent = pad(Math.floor(t % 86400 / 3600));
        if (m) m.textContent = pad(Math.floor(t % 3600 / 60));
        if (s) s.textContent = pad(t % 60);
      }
      tick();
      tickers.push(tick);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCountdowns(); });
  else initCountdowns();
  document.addEventListener('shopify:section:load', function (e) { initCountdowns(e.target); });
})();
